<!-- Vehicle Detail Modal -->
<div class="modal fade" id="kt_modal_proforma_vh_detail" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-xl modal-dialog-scrollable">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header pb-3 border-0 d-flex justify-content-between align-items-center">
        <!-- Left Side: Vehicle Title -->
        <h2 class="modal-title fw-bold mb-0">
          <span *ngIf="selectedVehicle">
            {{ selectedVehicle.year }} {{ selectedVehicle.make }} {{ selectedVehicle.model }}
          </span>
          <span *ngIf="!selectedVehicle">Vehicle Details</span>
        </h2>

        <!-- Right Side: Action Buttons -->
        <div class="d-flex align-items-center gap-2">
          <!-- View File Button (shown only when PDF is generated) -->
          <button
            *ngIf="pdfUrl"
            type="button"
            class="btn btn-sm btn-success"
            (click)="openPdf()"
          >
            <i class="bi bi-file-earmark-pdf me-1"></i>
            View File
          </button>

          <!-- Generate PDF Button -->
          <button
            type="button"
            class="btn btn-sm btn-primary"
            (click)="generatePdf()"
            [disabled]="isGeneratingPdf || !selectedVehicle"
          >
            <span *ngIf="!isGeneratingPdf">
              <i class="bi bi-file-earmark-arrow-down me-1"></i>
              Generate PDF
            </span>
            <span *ngIf="isGeneratingPdf">
              <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
              Generating...
            </span>
          </button>

          <!-- Close Button -->
          <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
            <i class="ki-duotone ki-cross fs-1">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
          </div>
        </div>
      </div>

      <!-- Modal Body -->
      <div class="modal-body px-lg-10 pb-lg-10">

        <!-- Loading State -->
        <div *ngIf="isLoading" class="text-center py-10">
          <div class="spinner-border text-primary mb-3" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <p class="text-muted">Loading vehicle details...</p>
        </div>

        <!-- Vehicle Details Content -->
        <div *ngIf="!isLoading && selectedVehicle" class="vehicle-detail-container">

          <!-- Vehicle Header Section -->
          <div class="vehicle-header mb-4">
            <h3 class="fw-bold text-gray-900 mb-4">{{selectedVehicle.year}} {{selectedVehicle.company_name}} {{selectedVehicle.name}}</h3>

            <!-- Vehicle Info Table -->
            <div class="table-responsive mb-4">
              <table class="table table-bordered align-middle">
                <thead>
                  <tr class="bg-light">
                    <th colspan="2" class="fw-bold text-gray-800">Vehicle Info</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="w-50">
                      <div class="row">
                        <div class="col-6">
                          <div class="d-flex align-items-start mb-2">
                            <div class="vehicle-image me-3">
                              <img src="{{selectedVehicle.pictures && selectedVehicle.pictures.length > 0 ? selectedVehicle.pictures[0] : 'assets/media/svg/files/blank-image.svg'}}" alt="Vehicle" class="img-fluid" style="width: 120px; height: 90px; object-fit: cover; border: 1px solid #e4e6ef;">
                            </div>
                            <div class="flex-grow-1">
                              <div class="mb-2">
                                <span class="fw-bold text-gray-700">Stock Number:</span>
                                <span class="text-gray-800 ms-2">{{selectedVehicle.car_no}}</span>
                              </div>
                              <div class="mb-2">
                                <span class="fw-bold text-gray-700">Type:</span>
                                <span class="text-gray-800 ms-2">{{selectedVehicle.vehicle_type?.name || '-'}}</span>
                              </div>
                              <div class="mb-2">
                                <span class="fw-bold text-gray-700">Color:</span>
                                <span class="text-gray-800 ms-2">{{selectedVehicle.color}}</span>
                              </div>
                              <div class="mb-2">
                                <span class="fw-bold text-gray-700">Steering:</span>
                                <span class="text-gray-800 ms-2" style="text-transform: capitalize;">{{selectedVehicle.steering}}</span>
                              </div>
                              <div class="mb-2">
                                <span class="fw-bold text-gray-700">Weight:</span>
                                <span class="text-gray-800 ms-2">{{selectedVehicle.weight || 0}} Kg</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="mb-2">
                            <span class="fw-bold text-gray-700">Chassis Number:</span>
                            <span class="text-gray-800 ms-2">{{selectedVehicle.vin_no || selectedVehicle.chassis_no}}</span>
                          </div>
                          <div class="mb-2">
                            <span class="fw-bold text-gray-700">Transmission:</span>
                            <span class="text-gray-800 ms-2">{{selectedVehicle.transmission}}</span>
                          </div>
                          <div class="mb-2">
                            <span class="fw-bold text-gray-700">Fuel:</span>
                            <span class="text-gray-800 ms-2">{{selectedVehicle.fuel_type}}</span>
                          </div>
                          <div class="mb-2">
                            <span class="fw-bold text-gray-700">Hours (Machinery):</span>
                            <span class="text-gray-800 ms-2">{{selectedVehicle.hours_machinery}}</span>
                          </div>
                          <div class="mb-2">
                            <span class="fw-bold text-gray-700">Loading Capacity:</span>
                            <span class="text-gray-800 ms-2">{{selectedVehicle.loading_capacity}}</span>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td class="w-50">
                      <div class="row">
                        <div class="col-6">
                          <div class="mb-2">
                            <span class="fw-bold text-gray-700">Fob Price:</span>
                            <span class="text-gray-800 ms-2">{{selectedVehicle.fob_price}}</span>
                          </div>
                          <div class="mb-2">
                            <span class="fw-bold text-gray-700">Engine Capacity:</span>
                            <span class="text-gray-800 ms-2">{{selectedVehicle.engine}}</span>
                          </div>
                          <div class="mb-2">
                            <span class="fw-bold text-gray-700">Drive:</span>
                            <span class="text-gray-800 ms-2">{{selectedVehicle.drive_2wd_4wd}}WD</span>
                          </div>
                          <div class="mb-2">
                            <span class="fw-bold text-gray-700">Exterior Grade:</span>
                            <span class="text-gray-800 ms-2">{{selectedVehicle.exterior_grade}}</span>
                          </div>
                          <div class="mb-2">
                            <span class="fw-bold text-gray-700">Doors:</span>
                            <span class="text-gray-800 ms-2">{{selectedVehicle.doors}}</span>
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="mb-2">
                            <span class="fw-bold text-gray-700">Model Code:</span>
                            <span class="text-gray-800 ms-2">{{selectedVehicle?.model_code_obj?.code}}</span>
                          </div>
                          <div class="mb-2">
                            <span class="fw-bold text-gray-700">Mileage:</span>
                            <span class="text-gray-800 ms-2">{{selectedVehicle.mileage}} Km</span>
                          </div>
                          <div class="mb-2">
                            <span class="fw-bold text-gray-700">Seating Capacity:</span>
                            <span class="text-gray-800 ms-2">{{selectedVehicle.seating_capacity}}</span>
                          </div>
                          <div class="mb-2">
                            <span class="fw-bold text-gray-700">Interior Grade:</span>
                            <span class="text-gray-800 ms-2">{{selectedVehicle.interior_grade}}</span>
                          </div>
                          <div class="mb-2">
                            <span class="fw-bold text-gray-700">Dimension:</span>
                            <span class="text-gray-800 ms-2">{{selectedVehicle.car_length}}X{{selectedVehicle.car_width}}X{{selectedVehicle.car_height}} = 12 m3</span>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Options Section -->
            <div class="table-responsive mb-4">
              <table class="table table-bordered">
                <thead>
                  <tr class="bg-light">
                    <th class="fw-bold text-gray-800">Options</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="text-gray-700">{{getVehiclePoints('accessories_and_options')}}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Remarks Section -->
            <div class="table-responsive mb-4">
              <table class="table table-bordered">
                <thead>
                  <tr class="bg-light">
                    <th class="fw-bold text-gray-800">Remarks (only for Admin)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="text-gray-700">--</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Good Points Section -->
            <div class="table-responsive mb-4">
              <table class="table table-bordered">
                <thead>
                  <tr class="bg-light">
                    <th class="fw-bold text-gray-800">Good Points</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="text-gray-700">{{getVehiclePoints('good_points')}}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Mechanical Faults Section -->
            <div class="table-responsive mb-4">
              <table class="table table-bordered">
                <thead>
                  <tr class="bg-light">
                    <th class="fw-bold text-gray-800">Mechanical Faults</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="text-gray-700">{{getVehiclePoints('mechanical_faults')}}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Accessories Section -->
            <div class="table-responsive mb-4">
              <table class="table table-bordered">
                <thead>
                  <tr class="bg-light">
                    <th class="fw-bold text-gray-800">Accessories</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="text-gray-700">{{getVehiclePoints('accessories_and_options')}}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Vehicle Remarks Section -->
            <div class="table-responsive mb-4">
              <table class="table table-bordered">
                <thead>
                  <tr class="bg-light">
                    <th class="fw-bold text-gray-800">Vehicle Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <table class="table table-borderless mb-0">
                        <tbody>
                          <tr>
                            <td class="fw-bold text-gray-700" style="width: 150px;">Remark Date</td>
                            <td class="fw-bold text-gray-700">Remarks</td>
                          </tr>
                          <tr *ngFor="let remark of selectedVehicle.vehicle_remarks">
                            <td class="text-gray-800">{{remark.created_at | date:'dd-MM-yy HH:mm'}}</td>
                            <td class="text-gray-800">{{remark.vehicle_remark}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Documents Uploaded Section -->
            <div class="table-responsive mb-4">
              <table class="table table-bordered">
                <thead>
                  <tr class="bg-light">
                    <th class="fw-bold text-gray-800">Documents Uploaded</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div *ngIf="selectedVehicle?.docs && selectedVehicle.docs.length > 0; else noDocuments">
                        <div class="row g-3">
                          <div class="col-md-6 col-lg-4" *ngFor="let docGroup of selectedVehicle.docs">
                            <div class="card h-100">
                              <div class="card-body">
                                <h6 class="card-title text-gray-800 fw-bold mb-3">
                                  {{ formatDocumentType(docGroup.type) }}
                                </h6>
                                <div class="d-flex flex-column gap-2">
                                  <a
                                    *ngFor="let url of docGroup.urls; let i = index"
                                    [href]="url"
                                    target="_blank"
                                    class="d-flex align-items-center text-primary text-hover-dark text-decoration-none"
                                  >
                                    <i class="bi bi-file-earmark-text fs-3 me-2"></i>
                                    <span class="text-truncate">
                                      {{ formatDocumentType(docGroup.type) }}{{ docGroup.urls.length > 1 ? ' (' + (i + 1) + ')' : '' }}
                                    </span>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <ng-template #noDocuments>
                        <p class="text-muted mb-0">No documents uploaded</p>
                      </ng-template>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Purchase Details Section -->
            <div class="table-responsive mb-4">
              <table class="table table-bordered">
                <thead>
                  <tr class="bg-light">
                    <th class="fw-bold text-gray-800">Purchase Details</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <table class="table table-borderless mb-0">
                        <tbody>
                          <tr>
                            <td class="fw-bold text-gray-700" style="width: 150px;">Auction Date</td>
                            <td class="fw-bold text-gray-700" style="width: 150px;">Auction Number</td>
                            <td class="fw-bold text-gray-700" style="width: 150px;">Auction Price</td>
                            <td class="fw-bold text-gray-700" style="width: 150px;">Purchase From</td>
                            <td class="fw-bold text-gray-700">Lot Number</td>
                          </tr>
                          <tr>
                            <td class="text-gray-800">{{selectedVehicle.auction_date | date:'dd-MM-yy'}}</td>
                            <td class="text-gray-800">{{selectedVehicle.inventory_no}}</td>
                            <td class="text-gray-800">{{selectedVehicle.price}} JPY</td>
                            <td class="text-gray-800">{{selectedVehicle.hall_name}}</td>
                            <td class="text-gray-800">{{selectedVehicle.lot_no}}</td>
                          </tr>
                          <tr>
                            <td class="fw-bold text-gray-700">Payment Ref. No.</td>
                            <td class="fw-bold text-gray-700">Bank</td>
                            <td class="fw-bold text-gray-700">Purchase Payment (JPY)</td>
                            <td class="fw-bold text-gray-700">Payment Date</td>
                            <td></td>
                          </tr>
                          <tr>
                            <td class="text-gray-800">--</td>
                            <td class="text-gray-800">--</td>
                            <td class="text-gray-800">--</td>
                            <td class="text-gray-800">--</td>
                            <td></td>
                          </tr>
                          <tr>
                            <td colspan="5" class="fw-bold text-gray-700">Admin Comment</td>
                          </tr>
                          <tr>
                            <td colspan="5" class="text-gray-800">--</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Sales Details Section -->
            <div class="table-responsive mb-4">
              <table class="table table-bordered">
                <thead>
                  <tr class="bg-light">
                    <th class="fw-bold text-gray-800">Sales Details</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <table class="table table-borderless mb-0">
                        <tbody>
                          <tr>
                            <td class="fw-bold text-gray-700" style="width: 150px;">Sales Contract No.</td>
                            <td class="fw-bold text-gray-700" style="width: 200px;">Company Name</td>
                            <td class="fw-bold text-gray-700" style="width: 150px;">Shipment Date</td>
                            <td class="fw-bold text-gray-700" style="width: 150px;">Order Date</td>
                            <td class="fw-bold text-gray-700">Port of Discharge</td>
                          </tr>
                          <tr>
                            <td class="text-gray-800">--</td>
                            <td class="text-gray-800">{{selectedVehicle?.invoice?.order?.buyer_company_name}}</td>
                            <td class="text-gray-800">{{selectedVehicle?.ship?.sailing_date | date:'dd-MM-yy'}}</td>
                            <td class="text-gray-800">{{selectedVehicle?.invoice?.order?.created_at | date:'dd-MM-yy'}}</td>
                            <td class="text-gray-800">--</td>
                          </tr>
                          <tr>
                            <td colspan="5" class="fw-bold text-gray-700">Sold To</td>
                          </tr>
                          <tr>
                            <td colspan="5" class="text-gray-800">{{selectedVehicle?.invoice?.order?.buyer_consignee_name}}</td>
                          </tr>
                          <tr>
                            <td class="fw-bold text-gray-700">Proforma Invoice No.</td>
                            <td class="fw-bold text-gray-700">Proforma Date</td>
                            <td class="fw-bold text-gray-700">Amount</td>
                            <td class="fw-bold text-gray-700">Created by</td>
                            <td class="fw-bold text-gray-700">Trade Terms</td>
                          </tr>
                          <tr>
                            <td class="text-gray-800">{{selectedVehicle?.invoice?.order?.order_number}}</td>
                            <td class="text-gray-800">{{selectedVehicle?.invoice?.order?.created_at | date:'dd-MM-yy'}}</td>
                            <td class="text-gray-800">{{selectedVehicle?.invoice?.order?.total_amount}} USD</td>
                            <td class="text-gray-800">{{selectedVehicle?.invoice?.order?.created_by?.name}}</td>
                            <td class="text-gray-800">{{selectedVehicle?.invoice?.order?.payment_terms}} | {{selectedVehicle?.invoice?.order?.to_country}}</td>
                          </tr>
                          <tr>
                            <td class="fw-bold text-gray-700">Invoice No.</td>
                            <td class="fw-bold text-gray-700">Invoice Date</td>
                            <td class="fw-bold text-gray-700">Amount</td>
                            <td class="fw-bold text-gray-700">Created by</td>
                            <td class="fw-bold text-gray-700">Trade Terms</td>
                          </tr>
                          <tr>
                            <td class="text-gray-800">{{selectedVehicle?.invoice?.invoice_number}}</td>
                            <td class="text-gray-800">{{selectedVehicle?.invoice?.created_at | date:'dd-MM-yy'}}</td>
                            <td class="text-gray-800">{{selectedVehicle?.invoice?.invoice_amount}} USD</td>
                            <td class="text-gray-800">{{selectedVehicle?.invoice?.created_by?.name}}</td>
                            <td class="text-gray-800">{{selectedVehicle?.invoice?.order?.payment_terms}} | {{selectedVehicle?.invoice?.order?.to_country}}</td>
                          </tr>
                          <tr>
                            <td colspan="5" class="fw-bold text-gray-700">Allocated Payment</td>
                          </tr>
                        </tbody>
                      </table>
                      <table class="table table-bordered mb-0">
                        <thead>
                          <tr class="bg-light">
                            <th class="fw-bold text-gray-700">Date</th>
                            <th class="fw-bold text-gray-700">Debit</th>
                            <th class="fw-bold text-gray-700">Credit</th>
                            <th class="fw-bold text-gray-700">Balance</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let allocation of getAllocations(selectedVehicle.invoice.allocations, +selectedVehicle.invoice.invoice_amount)">
                            <td class="text-gray-800">{{allocation.date | date:'dd-MM-yy'}}</td>
                            <td class="text-gray-800">{{allocation.debit}}</td>
                            <td class="text-gray-800">{{allocation.credit}}</td>
                            <td class="text-gray-800">{{allocation.balance}}</td>
                          </tr>
                          <!-- <tr>
                            <td class="text-gray-800">2025-12-19</td>
                            <td class="text-gray-800">--</td>
                            <td class="text-gray-800">1,252</td>
                            <td class="text-gray-800">11,488</td>
                          </tr>
                          <tr>
                            <td class="text-gray-800">2025-12-19</td>
                            <td class="text-gray-800">--</td>
                            <td class="text-gray-800">963</td>
                            <td class="text-gray-800">10,525</td>
                          </tr>
                          <tr>
                            <td class="text-gray-800">2025-12-19</td>
                            <td class="text-gray-800">--</td>
                            <td class="text-gray-800">2,344</td>
                            <td class="text-gray-800">8,181</td>
                          </tr>
                          <tr>
                            <td class="text-gray-800">2025-12-19</td>
                            <td class="text-gray-800">--</td>
                            <td class="text-gray-800">964</td>
                            <td class="text-gray-800">7,217</td>
                          </tr>
                          <tr>
                            <td class="text-gray-800">2025-12-19</td>
                            <td class="text-gray-800">--</td>
                            <td class="text-gray-800">964</td>
                            <td class="text-gray-800">6,253</td>
                          </tr>
                          <tr>
                            <td class="text-gray-800">2025-12-19</td>
                            <td class="text-gray-800">--</td>
                            <td class="text-gray-800">1,928</td>
                            <td class="text-gray-800">4,325</td>
                          </tr>
                          <tr>
                            <td class="text-gray-800">2025-12-19</td>
                            <td class="text-gray-800">--</td>
                            <td class="text-gray-800">2,362</td>
                            <td class="text-gray-800">1,963</td>
                          </tr>
                          <tr>
                            <td class="text-gray-800">2025-12-19</td>
                            <td class="text-gray-800">--</td>
                            <td class="text-gray-800">1,963</td>
                            <td class="text-gray-800">0</td>
                          </tr> -->
                          <tr class="bg-light">
                            <td class="fw-bold text-gray-700">Total</td>
                            <td class="fw-bold text-gray-700">{{selectedVehicle?.invoice?.invoice_amount}}</td>
                            <td class="fw-bold text-gray-700">{{getTotalAllocated(selectedVehicle?.invoice?.allocations)}}</td>
                            <td class="fw-bold text-gray-700">{{selectedVehicle?.invoice?.balance}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Transport Pick Up Section -->
            <div class="table-responsive mb-4">
              <table class="table table-bordered">
                <thead>
                  <tr class="bg-light">
                    <th class="fw-bold text-gray-800">Transport Pick Up</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <table class="table table-borderless mb-0">
                        <tbody>
                          <tr>
                            <td class="fw-bold text-gray-700" style="width: 150px;">Pick from</td>
                            <td class="fw-bold text-gray-700" style="width: 150px;">Delivered At</td>
                            <td class="fw-bold text-gray-700" style="width: 150px;">Order Date</td>
                            <td class="fw-bold text-gray-700">Yard In Date</td>
                          </tr>
                          <tr>
                            <td class="text-gray-800">{{selectedVehicle?.transport_pickup?.pickup_from}}</td>
                            <td class="text-gray-800">{{selectedVehicle?.transport_pickup?.delivered_at}}</td>
                            <td class="text-gray-800">{{selectedVehicle?.transport_pickup?.order_date | date:'dd-MM-yy'}}</td>
                            <td class="text-gray-800">{{selectedVehicle?.transport_pickup?.yard_in | date:'dd-MM-yy'}}</td>
                          </tr>
                          <tr>
                            <td colspan="4" class="fw-bold text-gray-700">Admin Comment</td>
                          </tr>
                          <tr>
                            <td colspan="4" class="text-gray-800">{{selectedVehicle?.transport_pickup?.admin_comment || '-'}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Masho Details Section -->
            <div class="table-responsive mb-4">
              <table class="table table-bordered">
                <thead>
                  <tr class="bg-light">
                    <th class="fw-bold text-gray-800">Masho Details</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <table class="table table-borderless mb-0">
                        <tbody>
                          <tr>
                            <td class="fw-bold text-gray-700" style="width: 150px;">Date of Application</td>
                            <td class="fw-bold text-gray-700" style="width: 150px;">Valid Upto</td>
                            <td class="fw-bold text-gray-700">Admin Comment</td>
                          </tr>
                          <tr>
                            <td class="text-gray-800">{{selectedVehicle?.masho?.masho_date | date:'dd-MM-yy'}}</td>
                            <td class="text-gray-800">{{selectedVehicle?.masho?.valid_until_date | date:'dd-MM-yy'}}</td>
                            <td class="text-gray-800">{{selectedVehicle?.masho?.admin_comment || '-'}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Export Certificate Section -->
            <div class="table-responsive mb-4">
              <table class="table table-bordered">
                <thead>
                  <tr class="bg-light">
                    <th class="fw-bold text-gray-800">Export Certificate</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <table class="table table-borderless mb-0">
                        <tbody>
                          <tr>
                            <td class="fw-bold text-gray-700" style="width: 150px;">Certificate No.</td>
                            <td class="fw-bold text-gray-700" style="width: 150px;">Ref. Number</td>
                            <td class="fw-bold text-gray-700" style="width: 150px;">Reg. Number</td>
                            <td class="fw-bold text-gray-700" style="width: 150px;">Reg. Date</td>
                            <td class="fw-bold text-gray-700">First Reg. Date</td>
                          </tr>
                          <tr>
                            <td class="text-gray-800">{{selectedVehicle?.export_certificate?.certificate_no}}</td>
                            <td class="text-gray-800">{{selectedVehicle?.export_certificate?.reference_number}}</td>
                            <td class="text-gray-800">{{selectedVehicle?.export_certificate?.registration_no}}</td>
                            <td class="text-gray-800">{{selectedVehicle?.export_certificate?.registration_date}}</td>
                            <td class="text-gray-800">{{selectedVehicle?.export_certificate?.first_reg_date}}</td>
                          </tr>
                          <tr>
                            <td class="fw-bold text-gray-700">Serial Number</td>
                            <td class="fw-bold text-gray-700" colspan="4">Vehicle Classification</td>
                          </tr>
                          <tr>
                            <td class="text-gray-800">{{selectedVehicle?.export_certificate?.makers_serial_number}}</td>
                            <td class="text-gray-800" colspan="4">{{selectedVehicle?.export_certificate?.classification_of_vehicle}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Inspection Details Section -->
            <div class="table-responsive mb-4">
              <table class="table table-bordered">
                <thead>
                  <tr class="bg-light">
                    <th class="fw-bold text-gray-800">Inspection Details</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <table class="table table-borderless mb-0">
                        <tbody>
                          <tr>
                            <td class="fw-bold text-gray-700" style="width: 150px;">Apply Date</td>
                            <td class="fw-bold text-gray-700" style="width: 150px;">Agency</td>
                            <td class="fw-bold text-gray-700" style="width: 150px;">Done Date</td>
                            <td class="fw-bold text-gray-700">Status</td>
                          </tr>
                          <tr>
                            <td class="text-gray-800">{{selectedVehicle?.inspection?.insp_apply_date | date:'dd-MM-yy'}}</td>
                            <td class="text-gray-800">{{selectedVehicle?.inspection?.inspection_agency?.company_name || '-'}}</td>
                            <td class="text-gray-800">{{selectedVehicle?.inspection?.insp_passed_date | date:'dd-MM-yy'}}</td>
                            <td class="text-gray-800">{{selectedVehicle?.inspection?.insp_status || '-'}}</td>
                          </tr>
                          <tr>
                            <td colspan="4" class="fw-bold text-gray-700">Status Comment</td>
                          </tr>
                          <tr>
                            <td colspan="4" class="text-gray-800">{{selectedVehicle?.inspection?.insp_status_comment || '-'}}</td>
                          </tr>
                          <tr>
                            <td colspan="4" class="fw-bold text-gray-700">Admin Comment</td>
                          </tr>
                          <tr>
                            <td colspan="4" class="text-gray-800">{{selectedVehicle?.inspection?.admin_comment || '-'}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Shipping Details Section -->
            <div class="table-responsive mb-4">
              <table class="table table-bordered">
                <thead>
                  <tr class="bg-light">
                    <th class="fw-bold text-gray-800">Shipping Details</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <table class="table table-borderless mb-0">
                        <tbody>
                          <tr>
                            <td class="fw-bold text-gray-700" style="width: 150px;">Port of Loading</td>
                            <td class="fw-bold text-gray-700" style="width: 150px;">Port of Discharge</td>
                            <td class="fw-bold text-gray-700" style="width: 150px;">ETD Date</td>
                            <td class="fw-bold text-gray-700" style="width: 150px;">ETA Date</td>
                            <td class="fw-bold text-gray-700">Booking Request Date</td>
                          </tr>
                          <tr>
                            <td class="text-gray-800">{{selectedVehicle?.invoice?.ship?.sailing_port || '-'}}, {{selectedVehicle?.invoice?.ship?.sailing_country || '-'}}</td>
                            <td class="text-gray-800">{{selectedVehicle?.invoice?.ship?.destination_port || '-'}}, {{selectedVehicle?.invoice?.ship?.destination_country || '-'}}</td>
                            <td class="text-gray-800">{{selectedVehicle?.invoice?.ship?.sailing_date | date:'dd-MM-yy'}}</td>
                            <td class="text-gray-800">{{selectedVehicle?.invoice?.ship?.arrival_date | date:'dd-MM-yy'}}</td>
                            <td class="text-gray-800">{{selectedVehicle?.invoice?.shipping_info?.book_request_date | date:'dd-MM-yy'}}</td>
                          </tr>
                          <tr>
                            <td class="fw-bold text-gray-700">Status</td>
                            <td class="fw-bold text-gray-700" colspan="4">Admin Comment</td>
                          </tr>
                          <tr>
                            <td class="text-gray-800">{{selectedVehicle?.invoice?.shipping_info?.status || '-'}}</td>
                            <td class="text-gray-800" colspan="4">{{selectedVehicle?.invoice?.admin_comment || '-'}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Courier Details Section -->
            <div class="table-responsive mb-4">
              <table class="table table-bordered">
                <thead>
                  <tr class="bg-light">
                    <th class="fw-bold text-gray-800">Courier Details</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <table class="table table-borderless mb-0">
                        <tbody>
                          <tr>
                            <td class="fw-bold text-gray-700" style="width: 150px;">Courier Company</td>
                            <td class="fw-bold text-gray-700" style="width: 150px;">Date</td>
                            <td class="fw-bold text-gray-700" style="width: 200px;">Tracking Number</td>
                            <td class="fw-bold text-gray-700">Tracking URL</td>
                          </tr>
                          <tr>
                            <td class="text-gray-800">{{selectedVehicle?.courier_manager?.courier_company?.company_name || '-'}}</td>
                            <td class="text-gray-800">{{selectedVehicle?.courier_manager?.order_date | date:'dd-MM-yy'}}</td>
                            <td class="text-gray-800">{{selectedVehicle?.courier_manager?.tracking_number || '-'}}</td>
                            <td class="text-gray-800">{{selectedVehicle?.courier_manager?.tracking_url || '-'}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Repair Details Section -->
            <div class="table-responsive mb-4">
              <table class="table table-bordered">
                <thead>
                  <tr class="bg-light">
                    <th class="fw-bold text-gray-800">Repair Details</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <table class="table table-borderless mb-0">
                        <tbody>
                          <tr>
                            <td class="fw-bold text-gray-700" style="width: 150px;">Repair order date</td>
                            <td class="fw-bold text-gray-700" style="width: 150px;">Problem</td>
                            <td class="fw-bold text-gray-700">Status</td>
                          </tr>
                          <tr>
                            <td class="text-gray-800">{{selectedVehicle?.repair?.order_date | date:'dd-MM-yy'}}</td>
                            <td class="text-gray-800">{{selectedVehicle?.repair?.problems}}</td>
                            <td class="text-gray-800">{{selectedVehicle?.repair?.status}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer border-0">
        <button type="button" class="btn btn-light" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
